import { render, staticRenderFns } from "./cuts.vue?vue&type=template&id=137970f0"
import script from "./cuts.vue?vue&type=script&lang=js"
export * from "./cuts.vue?vue&type=script&lang=js"
import style0 from "./cuts.vue?vue&type=style&index=0&id=137970f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports